import React from 'react';

export type ModerationQueueTab = 'rejected' | 'pending' | 'approved';

interface ModerationQueueSectionProps {
  queueTab: ModerationQueueTab;
  onQueueTabChange: (tab: ModerationQueueTab) => void;
  pendingCount: number;
  approvedCount: number;
  rejectedCount: number;
  pendingContent: React.ReactNode;
  approvedContent: React.ReactNode;
  rejectedContent: React.ReactNode;
  hint?: React.ReactNode;
}

const ModerationQueueSection: React.FC<ModerationQueueSectionProps> = ({
  queueTab,
  onQueueTabChange,
  pendingCount,
  approvedCount,
  rejectedCount,
  pendingContent,
  approvedContent,
  rejectedContent,
  hint,
}) => {
  const tabs: { id: ModerationQueueTab; label: string; count: number; modifier: string }[] = [
    { id: 'rejected', label: 'Rejected', count: rejectedCount, modifier: 'queue-tab--rejected' },
    { id: 'pending', label: 'Incoming', count: pendingCount, modifier: '' },
    { id: 'approved', label: 'Approved', count: approvedCount, modifier: 'queue-tab--approved' },
  ];

  const panelTitle =
    queueTab === 'pending' ? 'Incoming users' : queueTab === 'approved' ? 'Approved users' : 'Rejected users';

  const panelContent =
    queueTab === 'pending' ? pendingContent : queueTab === 'approved' ? approvedContent : rejectedContent;

  return (
    <section className="moderation-queues">
      {hint}
      <div className="queue-tabs" role="tablist" aria-label="Moderation queues">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={queueTab === tab.id}
            className={`queue-tab ${tab.modifier} ${queueTab === tab.id ? 'active' : ''}`}
            onClick={() => onQueueTabChange(tab.id)}
          >
            {tab.label}
            <span className="queue-tab-count">{tab.count}</span>
          </button>
        ))}
      </div>

      <article className="queue-panel queue-main">
        <header className="queue-head">
          <div>
            <p className="queue-kicker">Review queue</p>
            <h2>{panelTitle}</h2>
          </div>
          <span className="queue-count">
            {queueTab === 'pending' ? pendingCount : queueTab === 'approved' ? approvedCount : rejectedCount}
          </span>
        </header>
        <div className="queue-review-panel" role="tabpanel">
          {panelContent}
        </div>
      </article>
    </section>
  );
};

export default ModerationQueueSection;
